import { BlocksContent } from "@strapi/blocks-react-renderer";
import { SubscriptionState } from "./reducers/subscription";

export const REGISTER_CUSTOMER_REQUEST = "REGISTER_CUSTOMER_REQUEST";
export const CLEAR_USER_ERROR = "CLEAR_USER_ERROR";
export const REGISTER_CUSTOMER_SUCCESS = "REGISTER_CUSTOMER_SUCCESS";
export const REGISTER_CUSTOMER_FAIL = "REGISTER_CUSTOMER_FAIL";
export const CREATE_GROUP_REQUEST = "CREATE_GROUP_REQUEST";
export const CREATE_GROUP_SUCCESS = "CREATE_GROUP_SUCCESS";
export const CREATE_GROUP_FAIL = "CREATE_GROUP_FAIL";
export const LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL";
export const LOGOUT_USER = "LOGOUT_USER";
export const SET_LOGGED_IN = "SET_LOGGED_IN";
export const SET_LOADING = "SET_LOADING";
export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";
export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_EMPLOYER_FAIL";
export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";
export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";
export const DELETE_SERVICE_REQUEST = "DELETE_SERVICE_REQUEST";
export const DELETE_SERVICE_SUCCESS = "DELETE_SERVICE_SUCCESS";
export const DELETE_SERVICE_FAIL = "DELETE_SERVICE_FAIL";
export const DELETE_ORDER_REQUEST = "DELETE_ORDER_REQUEST";
export const DELETE_ORDER_SUCCESS = "DELETE_ORDER_SUCCESS";
export const DELETE_ORDER_FAIL = "DELETE_ORDER_FAIL";
export const UPDATE_GROUP_REQUEST = "UPDATE_GROUP_REQUEST";
export const UPDATE_GROUP_SUCCESS = "UPDATE_GROUP_SUCCESS";
export const UPDATE_GROUP_FAIL = "UPDATE_GROUP_FAIL";
export const DELETE_GROUP_MEMBER_REQUEST = "DELETE_GROUP_MEMBER_REQUEST";
export const SEND_EMAIL_MEMBER_REQUEST = "SEND_EMAIL_MEMBER_REQUEST";
export const SEND_EMAIL_MEMBER_SUCCESS = "SEND_EMAIL_MEMBER_SUCCESS";
export const SEND_EMAIL_MEMBER_FAIL = "SEND_EMAIL_MEMBER_FAIL";
export const SEND_EMAIL_CUSTOMER_REQUEST = "SEND_EMAIL_CUSTOMER_REQUEST";
export const SEND_EMAIL_CUSTOMER_SUCCESS = "SEND_EMAIL_CUSTOMER_SUCCESS";
export const SEND_EMAIL_CUSTOMER_FAIL = "SEND_EMAIL_CUSTOMER_FAIL";
export const CREATE_SERVICE_REQUEST = "CREATE_SERVICE_REQUEST";
export const CREATE_SERVICE_SUCCESS = "CREATE_SERVICE_SUCCESS";
export const CREATE_SERVICE_FAIL = "CREATE_SERVICE_FAIL";
export const GET_SERVICES_REQUEST = "GET_SERVICES_REQUEST";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAIL = "GET_SERVICES_FAIL";
export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAIL = "GET_PRODUCTS_FAIL";
export const GET_SHIPPING_REQUEST = "GET_SHIPPING_REQUEST";
export const GET_SHIPPING_SUCCESS = "GET_SHIPPING_SUCCESS";
export const GET_SHIPPING_FAIL = "GET_SHIPPING_FAIL";
export const UPDATE_PRODUCTS = "UPDATE_PRODUCTS";
export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const RESET_CART = "RESET";
export const RESET_BLOG = "RESET_BLOG";
export const RESET_COUPONS = "RESET_COUPONS";
export const RESET_USERS = "RESET_USERS";
export const RESET_ORDERS = "RESET_ORDERS";
export const SAVE_SHIPPING_ADDRESS = "SAVE_SHIPPING_ADDRESS";
export const SAVE_PAYMENT_METHOD = "SAVE_PAYMENT_METHOD";
export const SAVE_STRIPE_PAYMENT_METHOD = "SAVE_STRIPE_PAYMENT_METHOD";
export const GET_ORDERS_REQUEST = "GET_ORDERS_REQUEST";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAIL = "GET_ORDERS_FAIL";
export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL";
export const SEND_CONTACT_MAIL_REQUEST = "SEND_CONTACT_MAIL_REQUEST";
export const SEND_CONTACT_MAIL_SUCCESS = "SEND_CONTACT_MAIL_SUCCESS";
export const SEND_CONTACT_MAIL_FAIL = "SEND_CONTACT_MAIL_FAIL";
export const SET_COUPON = "SET_COUPON";
export const DELETE_ALERT_REQUEST = "DELETE_ALERT_REQUEST";
export const DELETE_ALERT_SUCCESS = "DELETE_ALERT_SUCCESS";
export const DELETE_ALERT_FAIL = "DELETE_ALERT_FAIL";
export const CREATE_ALERT_REQUEST = "CREATE_ALERT_REQUEST";
export const CREATE_ALERT_SUCCESS = "CREATE_ALERT_SUCCESS";
export const CREATE_ALERT_FAIL = "CREATE_ALERT_FAIL";
export const GET_ALERTS_REQUEST = "GET_ALERTS_REQUEST";
export const GET_ALERTS_SUCCESS = "GET_ALERTS_SUCCESS";
export const GET_ALERTS_FAIL = "GET_ALERTS_FAIL";
export const DELETE_COUPON_REQUEST = "DELETE_COUPON_REQUEST";
export const DELETE_COUPON_SUCCESS = "DELETE_COUPON_SUCCESS";
export const DELETE_COUPON_FAIL = "DELETE_COUPON_FAIL";
export const CREATE_COUPON_REQUEST = "CREATE_COUPON_REQUEST";
export const CREATE_COUPON_SUCCESS = "CREATE_COUPON_SUCCESS";
export const CREATE_COUPON_FAIL = "CREATE_COUPON_FAIL";
export const GET_COUPONS_REQUEST = "GET_COUPONS_REQUEST";
export const GET_COUPONS_SUCCESS = "GET_COUPONS_SUCCESS";
export const GET_COUPONS_FAIL = "GET_COUPONS_FAIL";
export const GET_BLOGS_REQUEST = "GET_BLOGS_REQUEST";
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS";
export const GET_BLOGS_FAIL = "GET_BLOGS_FAIL";
export const DELETE_SENIOR_HOME_REQUEST = "DELETE_SENIOR_HOME_REQUEST";
export const DELETE_SENIOR_HOME_SUCCESS = "DELETE_SENIOR_HOME_SUCCESS";
export const DELETE_SENIOR_HOME_FAIL = "DELETE_SENIOR_HOME_FAIL";
export const CREATE_SENIOR_HOME_REQUEST = "CREATE_SENIOR_HOME_REQUEST";
export const CREATE_SENIOR_HOME_SUCCESS = "CREATE_SENIOR_HOME_SUCCESS";
export const CREATE_SENIOR_HOME_FAIL = "CREATE_SENIOR_HOME_FAIL";
export const GET_SENIOR_HOMES_REQUEST = "GET_SENIOR_HOMES_REQUEST";
export const GET_SENIOR_HOMES_SUCCESS = "GET_SENIOR_HOMES_SUCCESS";
export const GET_SENIOR_HOMES_FAIL = "GET_SENIOR_HOMES_FAIL";
export const CLEAR_SENIOR_HOMES = "CLEAR_SENIOR_HOMES";
export const GET_NURSES_FAIL = "GET_NURSES_FAIL";
export const GET_NURSES_REQUEST = "GET_NURSES_REQUEST";
export const GET_NURSES_SUCCESS = "GET_NURSES_SUCCESS";
export const GET_NURSE_PROFILE_REQUEST = "GET_NURSE_PROFILE_REQUEST";
export const GET_NURSE_PROFILE_SUCCESS = "GET_NURSE_PROFILE_SUCCESS";
export const GET_NURSE_PROFILE_FAILED = "GET_NURSE_PROFILE_FAILED";
export const ADD_NURSE_REQUEST = "ADD_NURSE_REQUEST";
export const ADD_NURSE_SUCCESS = "ADD_NURSE_SUCCESS";
export const ADD_NURSE_FAILED = "ADD_NURSE_FAILED";
export const UPDATE_NURSE_REQUEST = "UPDATE_NURSE_REQUEST";
export const UPDATE_NURSE_SUCCESS = "UPDATE_NURSE_SUCCESS";
export const UPDATE_NURSE_FAILED = "UPDATE_NURSE_FAILED";
export const DELETE_NURSE_REQUEST = "DELETE_NURSE_REQUEST";
export const DELETE_NURSE_REQUEST_SUCCESS = "DELETE_NURSE_REQUEST_SUCCESS";
export const DELETE_NURSE_REQUEST_FAILED = "DELETE_NURSE_REQUEST_FAILED";
export const ASSIGNED_SENIOR_REQUEST = "ASSIGNED_SENIOR_REQUEST";
export const ASSIGNED_SENIOR_SUCCESS = "ASSIGNED_SENIOR_SUCCESS";
export const ASSIGNED_SENIOR_FAILED = "ASSIGNED_SENIOR_FAILED";
export const ASSIGNED_SENIOR_LIST_REQUEST = "ASSIGNED_SENIOR_LIST_REQUEST";
export const ASSIGNED_SENIOR_LIST_SUCCESS = "ASSIGNED_SENIOR_LIST_SUCCESS";
export const ASSIGNED_SENIOR_LIST_FAILED = "ASSIGNED_SENIOR_LIST_FAILED";
export const SIGNUP_NURSE_REQUSET = "SIGNUP_NURSE_REQUSET";
export const SIGNUP_NURSE_SUCCESS = "SIGNUP_NURSE_SUCCESS";
export const SIGNUP_NURSE_FAILED = "SIGNUP_NURSE_FAILED";
export const GET_ITSUPPORT_LIST_REQUEST = "GET_ITSUPPORT_LIST_REQUEST";
export const GET_ITSUPPORT_LIST_SUCCESS = "GET_ITSUPPORT_LIST_SUCCESS";
export const GET_ITSUPPORT_LIST_FAIL = "GET_ITSUPPORT_LIST_FAIL";
export const GET_ITSUPPORT_PROFILE_REQUEST = "GET_ITSUPPORT_PROFILE_REQUEST";
export const GET_ITSUPPORT_PROFILE_SUCCESS = "GET_ITSUPPORT_PROFILE_SUCCESS";
export const GET_ITSUPPORT_PROFILE_FAIL = "GET_ITSUPPORT_PROFILE_FAIL";
export const UPDATE_ITSUPPORT_PROFILE_REQUEST = "UPDATE_ITSUPPORT_PROFILE_REQUEST";
export const UPDATE_ITSUPPORT_PROFILE_SUCCESS = "UPDATE_ITSUPPORT_PROFILE_SUCCESS";
export const UPDATE_ITSUPPORT_PROFILE_FAIL = "UPDATE_ITSUPPORT_PROFILE_FAIL";
export const SEND_INVITE_ITSUPPORT_REQUEST = "SEND_INVITE_ITSUPPORT_REQUEST";
export const SEND_INVITE_ITSUPPORT_SUCCESS = "SEND_INVITE_ITSUPPORT_SUCCESS";
export const SEND_INVITE_ITSUPPORT_FAIL = "SEND_INVITE_ITSUPPORT_FAIL";
export const SIGNUP_ITSUPPORT_REQUEST = "SIGNUP_ITSUPPORT_REQUEST";
export const SIGNUP_ITSUPPORT_SUCCESS = "SIGNUP_ITSUPPORT_SUCCESS";
export const SIGNUP_ITSUPPORT_FAIL = "SIGNUP_ITSUPPORT_FAIL";
export const GET_USER_EDIT_FORM_DATA_REQUEST = "GET_USER_EDIT_FORM_DATA_REQUEST";
export const GET_USER_EDIT_FORM_DATA_SUCCESS = "GET_USER_EDIT_FORM_DATA_SUCCESS";
export const GET_USER_EDIT_FORM_DATA_FAIL = "GET_USER_EDIT_FORM_DATA_FAIL";
export const SET_USER_EDIT_FORM_DATA_REQUEST = "SET_USER_EDIT_FORM_DATA_REQUEST";
export const SET_USER_EDIT_FORM_DATA_SUCCESS = "SET_USER_EDIT_FORM_DATA_SUCCESS";
export const SET_USER_EDIT_FORM_DATA_FAIL = "SET_USER_EDIT_FORM_DATA_FAIL";
export const RESET_ITSUPPORT_MESSAGE = "RESET_ITSUPPORT_MESSAGE";
export const SET_ITSUPPORT_MESSAGE = "SET_ITSUPPORT_MESSAGE";
export const RESET_NURSE_MESSAGE = "RESET_NURSE_MESSAGE";
export const SET_NURSE_MESSAGE = "SET_NURSE_MESSAGE";
export const UPDATE_USER_EDIT_REQUEST = "UPDATE_USER_EDIT_REQUEST";
export const UPDATE_USER_EDIT_REQUEST_SUCCESS = "UPDATE_USER_EDIT_REQUEST_SUCCESS";
export const UPDATE_USER_EDIT_REQUEST_FAIL = "UPDATE_USER_EDIT_REQUEST_FAIL";
export const DELETE_IT_SUPPORT_PROFILE_REQUEST = "DELETE_IT_SUPPORT_PROFILE_REQUEST";
export const DELETE_IT_SUPPORT_PROFILE_REQUEST_SUCCESS = "DELETE_IT_SUPPORT_PROFILE_REQUEST_SUCCESS";
export const DELETE_IT_SUPPORT_PROFILE_REQUEST_FAILED = "DELETE_IT_SUPPORT_PROFILE_REQUEST_FAILED";
export const JOIN_ROOM_REQUEST = "JOIN_ROOM_REQUEST";
export const JOIN_ROOM_REQUEST_SUCCESS = "JOIN_ROOM_REQUEST_SUCCESS";
export const JOIN_ROOM_REQUEST_FAIL = "JOIN_ROOM_REQUEST_FAIL";
export const RESET_VIDEO_MEET = "RESET_VIDEO_MEET";
export const SET_LK_TOKEN = "SET_LK_TOKEN";
export const SET_PRE_JOIN_TOKEN = "SET_PRE_JOIN_TOKEN";
export const REMOVE_ROOM_NAME = "REMOVE_ROOM_NAME";
export const GET_FAQS_REQUEST = "GET_FAQS_REQUEST";
export const GET_FAQS_SUCCESS = "GET_FAQS_SUCCESS";
export const GET_FAQS_FAIL = "GET_FAQS_FAIL";

// Credential
export type Credential = {
    username: string;
    password: string;
};

// User
export type User = {
    id: number | null;
    username: string;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    device_imei4?: string;
    image?: string;
    nursingHome?: string;
    department?: string;
    homeAddress?: string;
    homeCity?: string;
    homePostalCode?: string;
    nursingHomeAddress?: string;
    role?: string;
    isAdmin: boolean;
    readOnly: boolean;
    group: Group;
    orders?: any[];
    isSenior: boolean;
    loading: boolean;
    error: any;
    stripePublicKey: string;
    tabletLanguage: any;
    autoAnswer: any;
    serviceOption: any;
    chosenService: any;
    supportStaff?: { id: string; seniorHomeIds?: number };
    appOnly: boolean;
    userType: string;
};

export type UserState = User & {
    isLoggedIn: boolean;
};

export type Users = {
    list: any[];
    loading: boolean;
    error: any;
    profile: {};
};

export type Orders = {
    list: any[];
    loading: boolean;
    error: any;
};

// Customer
export type Customer = {
    username: string;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    device_imei4?: string;
    image?: string;
    role?: string;
    isAdmin: boolean;
};

// Register customer
export type RegisterCustomerRequestAction = {
    type: typeof REGISTER_CUSTOMER_REQUEST;
    payload: {
        username: string;
        email: string;
        password: string;
        firstName: string;
        lastName: string;
        role: string;
        appOnly: boolean;
        history: any;
        redirect: any;
        seniorHomeId?: number;
        adminFlag?: boolean;
        mobileNumber?: string;
        country?: string;
        customerTrialEmailId?: number;
    };
};

// Clear user error
export type ClearUserErrorAction = {
    type: typeof CLEAR_USER_ERROR;
    payload: {};
};

export type RegisterCustomerSuccessAction = {
    type: typeof REGISTER_CUSTOMER_SUCCESS;
    payload: {
        username: string;
        email: string;
        password: string;
        firstName: string;
        lastName: string;
        role: string;
    };
};

export type RegisterCustomerFailAction = {
    type: typeof REGISTER_CUSTOMER_FAIL;
    payload: {
        error: any;
    };
};

// Login
export type LoginUserRequestAction = {
    type: typeof LOGIN_USER_REQUEST;
    payload: {
        credential: {
            username: string;
            password: string;
        };
        redirect: any;
        history: any;
    };
};

export type LoginUserSuccessAction = {
    type: typeof LOGIN_USER_SUCCESS;
    payload: User;
};

export type LoginUserFailAction = {
    type: typeof LOGIN_USER_FAIL;
    payload: {
        error: any;
    };
};

export type LogoutUserAction = {
    type: typeof LOGOUT_USER;
};

export type SetLoggedInAction = {
    type: typeof SET_LOGGED_IN;
};

export type SetLoadingAction = {
    type: typeof SET_LOADING;
};

// Get users
export type GetUsersRequestAction = {
    type: typeof GET_USERS_REQUEST;
};

export type GetUsersSuccessAction = {
    type: typeof GET_USERS_SUCCESS;
    payload: User;
};

export type GetUsersFailAction = {
    type: typeof GET_USERS_FAIL;
    payload: {
        error: any;
    };
};

export type GetOrdersRequestAction = {
    type: typeof GET_ORDERS_REQUEST;
};

export type GetOrdersSuccessAction = {
    type: typeof GET_ORDERS_SUCCESS;
    payload: Order;
};

export type GetOrdersFailAction = {
    type: typeof GET_ORDERS_FAIL;
    payload: {
        error: any;
    };
};

// Get user
export type GetUserRequestAction = {
    type: typeof GET_USER_REQUEST;
};

export type GetUserSuccessAction = {
    type: typeof GET_USER_SUCCESS;
    payload: User;
};

export type GetUserFailAction = {
    type: typeof GET_USER_FAIL;
    payload: {
        error: any;
    };
};

// Update user
export type UserUpdate = {
    id: any;
    username: string;
    email: string;
    password?: string;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    device_imei4?: string;
    nursingHome?: string;
    department?: string;
    homeAddress?: string;
    homeCity?: string;
    homePostalCode?: string;
    nursingHomeAddress?: string;
    image?: string;
    role?: string;
    isAdmin: boolean;
    error: any;
    success: any;
    isSenior: boolean;
    tabletLanguage?: string;
    autoAnswer?: string;
    serviceOption?: string;
    chosenService?: string;
    relativeDoneEmailId?: number;
};

export type UpdateUserRequestAction = {
    type: typeof UPDATE_USER_REQUEST;
    payload: Partial<UserUpdate>;
};

export type UpdateUserSuccessAction = {
    type: typeof UPDATE_USER_SUCCESS;
    payload: User;
};

export type UpdateUserFailAction = {
    type: typeof UPDATE_USER_FAIL;
    payload: {
        error: any;
    };
};

export type DeleteUserRequestAction = {
    type: typeof DELETE_USER_REQUEST;
    payload: User;
};

export type DeleteUserSuccessAction = {
    type: typeof DELETE_USER_SUCCESS;
};

export type DeleteUserFailAction = {
    type: typeof DELETE_USER_FAIL;
    payload: {
        error: any;
    };
};

export type DeleteOrderRequestAction = {
    type: typeof DELETE_ORDER_REQUEST;
    payload: Order;
};

export type DeleteOrderSuccessAction = {
    type: typeof DELETE_ORDER_SUCCESS;
};

export type DeleteOrderFailAction = {
    type: typeof DELETE_ORDER_FAIL;
    payload: {
        error: any;
    };
};

export type DeleteServiceRequestAction = {
    type: typeof DELETE_SERVICE_REQUEST;
    payload: ServiceItem;
};

export type DeleteServiceSuccessAction = {
    type: typeof DELETE_SERVICE_SUCCESS;
};

export type DeleteServiceFailAction = {
    type: typeof DELETE_SERVICE_FAIL;
    payload: {
        error: any;
    };
};

export type DeleteAlertRequestAction = {
    type: typeof DELETE_ALERT_REQUEST;
    payload: AlertItem;
};

export type DeleteAlertSuccessAction = {
    type: typeof DELETE_ALERT_SUCCESS;
};

export type DeleteAlertFailAction = {
    type: typeof DELETE_ALERT_FAIL;
    payload: {
        error: any;
    };
};

export type DeleteSeniorHomeRequestAction = {
    type: typeof DELETE_SENIOR_HOME_REQUEST;
    payload: SeniorHomeItem;
};

export type DeleteSeniorHomeSuccessAction = {
    type: typeof DELETE_SENIOR_HOME_SUCCESS;
};

export type DeleteSeniorHomeFailAction = {
    type: typeof DELETE_SENIOR_HOME_FAIL;
    payload: {
        error: any;
    };
};

export type DeleteCouponRequestAction = {
    type: typeof DELETE_COUPON_REQUEST;
    payload: CouponItem;
};

export type DeleteCouponSuccessAction = {
    type: typeof DELETE_COUPON_SUCCESS;
};

export type DeleteCouponFailAction = {
    type: typeof DELETE_COUPON_FAIL;
    payload: {
        error: any;
    };
};

export type CreateGroupRequestAction = {
    type: typeof CREATE_GROUP_REQUEST;
    payload: GroupState;
};

export type CreateGroupSuccessAction = {
    type: typeof CREATE_GROUP_SUCCESS;
    payload: Group;
};

export type CreateGroupFailAction = {
    type: typeof CREATE_GROUP_FAIL;
    payload: {
        error: any;
    };
};

export type GroupUpdate = {
    id: any;
    username: string;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    device_imei4?: string;
    image?: string;
    nursingHome?: string;
    department?: string;
    homeAddress?: string;
    homeCity?: string;
    homePostalCode?: string;
    nursingHomeAddress?: string;
    role?: string;
    isAdmin: boolean;
    members: any[];
    relativeCreateEmailId?: number;
    customerSeniorEmailId?: number;
};

export type UpdateGroupRequestAction = {
    type: typeof UPDATE_GROUP_REQUEST;
    payload: Partial<GroupUpdate>;
};

export type DeleteGroupMemberRequestAction = {
    type: typeof DELETE_GROUP_MEMBER_REQUEST;
    payload: { memberId: string };
};

export type UpdateGroupSuccessAction = {
    type: typeof UPDATE_GROUP_SUCCESS;
    payload: Group;
};

export type UpdateGroupFailAction = {
    type: typeof UPDATE_GROUP_FAIL;
    payload: {
        error: any;
    };
};

// emails
export type Email = {
    email: string;
    firstName: string;
    templateId?: number;
};

export type SendEmailMemberRequestAction = {
    type: typeof SEND_EMAIL_MEMBER_REQUEST;
    payload: Email;
};

export type SendEmailMemberSuccessAction = {
    type: typeof SEND_EMAIL_MEMBER_SUCCESS;
    payload: Email;
};

export type SendEmailMemberSuccessFailAction = {
    type: typeof SEND_EMAIL_MEMBER_SUCCESS;
    payload: {
        error: any;
    };
};

export type SendEmailCustomerRequestAction = {
    type: typeof SEND_EMAIL_CUSTOMER_REQUEST;
    payload: Email;
};

export type SendEmailCustomerSuccessAction = {
    type: typeof SEND_EMAIL_CUSTOMER_SUCCESS;
    payload: Email;
};

export type SendEmailCustomerSuccessFailAction = {
    type: typeof SEND_EMAIL_CUSTOMER_SUCCESS;
    payload: {
        error: any;
    };
};

export type Mail = {
    name: string;
    email: string;
    text: string;
};

export type SendContactMailRequestAction = {
    type: typeof SEND_CONTACT_MAIL_REQUEST;
    payload: Mail;
};

export type SendContactMailSuccessAction = {
    type: typeof SEND_CONTACT_MAIL_SUCCESS;
    payload: Mail;
};

export type SendContactMailFailAction = {
    type: typeof SEND_CONTACT_MAIL_FAIL;
    payload: {
        error: any;
    };
};

// Get User Profile
export type GetUserEditFormDataRequestAction = {
    type: typeof GET_USER_EDIT_FORM_DATA_REQUEST;
    payload: any;
};

export type GetUserEditFormDataRequestSuccessAction = {
    type: typeof GET_USER_EDIT_FORM_DATA_SUCCESS;
    payload: any;
};

export type GetUserEditFormDataRequestFailAction = {
    type: typeof GET_USER_EDIT_FORM_DATA_FAIL;
    payload: any;
};

// Update User Profile
export type SetUserEditFormDataRequestAction = {
    type: typeof SET_USER_EDIT_FORM_DATA_REQUEST;
    payload: any;
};

export type SetUserEditFormDataRequestSuccessAction = {
    type: typeof SET_USER_EDIT_FORM_DATA_SUCCESS;
};

export type SetUserEditFormDataRequestFailAction = {
    type: typeof SET_USER_EDIT_FORM_DATA_FAIL;
    payload: any;
};

export type UserActions =
    | RegisterCustomerRequestAction
    | RegisterCustomerSuccessAction
    | RegisterCustomerFailAction
    | LoginUserRequestAction
    | LoginUserSuccessAction
    | LoginUserFailAction
    | LogoutUserAction
    | SetLoggedInAction
    | SetLoadingAction
    | GetUserRequestAction
    | GetUserSuccessAction
    | GetUserFailAction
    | UpdateUserRequestAction
    | UpdateUserSuccessAction
    | UpdateUserFailAction
    | UpdateGroupRequestAction
    | UpdateGroupSuccessAction
    | UpdateGroupFailAction
    | DeleteGroupMemberRequestAction
    | DeleteUserRequestAction
    | DeleteUserSuccessAction
    | DeleteUserFailAction
    | CreateGroupRequestAction
    | CreateGroupSuccessAction
    | CreateGroupFailAction
    | GetUsersRequestAction
    | GetUsersSuccessAction
    | GetUsersFailAction
    | SendEmailMemberRequestAction
    | SendEmailMemberSuccessAction
    | SendEmailMemberSuccessFailAction
    | SendEmailCustomerRequestAction
    | SendEmailCustomerSuccessAction
    | SendEmailCustomerSuccessFailAction
    | SendContactMailRequestAction
    | SendContactMailSuccessAction
    | SendContactMailFailAction
    | DeleteServiceRequestAction
    | DeleteServiceSuccessAction
    | DeleteServiceFailAction
    | GetOrdersRequestAction
    | GetOrdersSuccessAction
    | GetOrdersFailAction
    | GetUserEditFormDataRequestAction
    | GetUserEditFormDataRequestSuccessAction
    | GetUserEditFormDataRequestFailAction
    | SetUserEditFormDataRequestAction
    | SetUserEditFormDataRequestSuccessAction
    | SetUserEditFormDataRequestFailAction
    | ResetUsersAction
    | UpdateUserEditRequestAction
    | UpdateUserEditRequestSuccessAction
    | UpdateUserEditRquestFailAction;

// Services
export type Service = {
    id: number;
    name: string;
    description: string;
    price: number;
    category: string;
    shippingCategory: any;
    isActive: boolean;
    stripeProductId: string;
    stripeShippingRateId: string;
    stripeShippingRateIdFree: string;
    priceType: string;
    period: number | null | undefined;
    photoShow: boolean;
    photoLink: string | null | undefined;
    photoDescription: string | null | undefined;
};

export type ServiceItem = {
    id: any;
    sortNumber: any;
    name: string;
    descriptionFirst: string;
    descriptionSecond: string;
    price: number;
    category: string;
    shippingCategory: any;
    isActive: boolean;
    stripeProductId: string;
    stripeShippingRateId: string;
    stripeShippingRateIdFree: string;
    priceType: string;
    period: number | null | undefined;
    photoShow: boolean;
    photoLink: string | null | undefined;
    photoDescription: string | null | undefined;
};

export type AlertItem = {
    id: any;
    createdAt: any;
    updatedAt: any;
    text: string;
    start: any;
    end: any;
};

export type SeniorHomeItem = {
    id: any;
    createdAt: any;
    updatedAt: any;
    reference: string;
    name: string;
    show: boolean;
};

export type CouponItem = {
    id: any;
    createdAt: any;
    updatedAt: any;
    code: string;
    data: any;
};

export type CreateServiceRequestAction = {
    type: typeof CREATE_SERVICE_REQUEST;
    payload: {
        service: Service;
    };
};

export type CreateServiceSuccessAction = {
    type: typeof CREATE_SERVICE_SUCCESS;
    payload: {
        service: Service;
    };
};

export type CreateServiceFailAction = {
    type: typeof CREATE_SERVICE_FAIL;
    payload: {
        error: any;
    };
};

export type CreateAlertRequestAction = {
    type: typeof CREATE_ALERT_REQUEST;
    payload: {
        alert: AlertItem;
    };
};

export type CreateAlertSuccessAction = {
    type: typeof CREATE_ALERT_SUCCESS;
    payload: {
        alert: AlertItem;
    };
};

export type CreateAlertFailAction = {
    type: typeof CREATE_ALERT_FAIL;
    payload: {
        error: any;
    };
};

export type CreateSeniorHomeRequestAction = {
    type: typeof CREATE_SENIOR_HOME_REQUEST;
    payload: {
        senior_home: SeniorHomeItem;
    };
};

export type CreateSeniorHomeSuccessAction = {
    type: typeof CREATE_SENIOR_HOME_SUCCESS;
    payload: {
        senior_home: SeniorHomeItem;
    };
};

export type CreateSeniorHomeFailAction = {
    type: typeof CREATE_SENIOR_HOME_FAIL;
    payload: {
        error: any;
    };
};

export type CreateCouponRequestAction = {
    type: typeof CREATE_COUPON_REQUEST;
    payload: {
        coupon: CouponItem;
    };
};

export type CreateCouponSuccessAction = {
    type: typeof CREATE_COUPON_SUCCESS;
    payload: {
        coupon: CouponItem;
    };
};

export type CreateCouponFailAction = {
    type: typeof CREATE_COUPON_FAIL;
    payload: {
        error: any;
    };
};

export type GetServicesRequestAction = {
    type: typeof GET_SERVICES_REQUEST;
};

export type GetServicesSuccessAction = {
    type: typeof GET_SERVICES_SUCCESS;
    payload: Service[];
};

export type GetServicesFailAction = {
    type: typeof GET_SERVICES_FAIL;
    payload: {
        error: any;
    };
};

export type GetProductsRequestAction = {
    type: typeof GET_PRODUCTS_REQUEST;
    payload: string;
};
export type GetProductsSuccessAction = {
    type: typeof GET_PRODUCTS_SUCCESS;
    payload: ProductType[];
};
export type GetProductsFailAction = {
    type: typeof GET_PRODUCTS_FAIL;
    payload: {
        error: any;
    };
};
export type GetShippingRequestAction = {
    type: typeof GET_SHIPPING_REQUEST;
};
export type GetShippingSuccessAction = {
    type: typeof GET_SHIPPING_SUCCESS;
    payload: ShippingMethod[];
};
export type GetShippingFailAction = {
    type: typeof GET_SHIPPING_FAIL;
    payload: {
        error: any;
    };
};
export type UpdateProductsAction = {
    type: typeof UPDATE_PRODUCTS;
    payload: ProductType[];
};

export type GetCategoriesRequestAction = {
    type: typeof GET_CATEGORIES_REQUEST;
    payload: string;
};
export type GetCategoriesSuccessAction = {
    type: typeof GET_CATEGORIES_SUCCESS;
    payload: CategoryType;
};

export type GetCategoriesFailAction = {
    type: typeof GET_CATEGORIES_FAIL;
    payload: {
        error: any;
    };
};

export type ClearCategoriesAction = {
    type: typeof CLEAR_CATEGORIES;
};

export type GetAlertsRequestAction = {
    type: typeof GET_ALERTS_REQUEST;
};

export type GetAlertsSuccessAction = {
    type: typeof GET_ALERTS_SUCCESS;
    payload: AlertItem[];
};

export type GetAlertsFailAction = {
    type: typeof GET_ALERTS_FAIL;
    payload: {
        error: any;
    };
};

export type GetSeniorHomesRequestAction = {
    type: typeof GET_SENIOR_HOMES_REQUEST;
};

export type GetSeniorHomesSuccessAction = {
    type: typeof GET_SENIOR_HOMES_SUCCESS;
    payload: SeniorHomeItem[];
};

export type GetSeniorHomesFailAction = {
    type: typeof GET_SENIOR_HOMES_FAIL;
    payload: {
        error: any;
    };
};

export type ClearSeniorHomesAction = {
    type: "CLEAR_SENIOR_HOMES";
};

export type GetBlogsRequestAction = {
    type: typeof GET_BLOGS_REQUEST;
};

export type GetBlogsSuccessAction = {
    type: typeof GET_BLOGS_SUCCESS;
    payload: BlogItem[];
};

export type GetBlogsFailAction = {
    type: typeof GET_BLOGS_FAIL;
    payload: {
        error: any;
    };
};

export type GetCouponsRequestAction = {
    type: typeof GET_COUPONS_REQUEST;
};

export type GetCouponsSuccessAction = {
    type: typeof GET_COUPONS_SUCCESS;
    payload: CouponItem[];
};

export type GetCouponsFailAction = {
    type: typeof GET_COUPONS_FAIL;
    payload: {
        error: any;
    };
};

export type ServicesActions =
    | GetServicesRequestAction
    | GetServicesSuccessAction
    | GetServicesFailAction
    | CreateServiceRequestAction
    | CreateServiceSuccessAction
    | CreateServiceFailAction
    | DeleteServiceRequestAction
    | DeleteServiceSuccessAction
    | DeleteServiceFailAction;

export type ProductsActions = GetProductsRequestAction | GetProductsSuccessAction | GetProductsFailAction | UpdateProductsAction;
export type CategoriesActions = GetCategoriesRequestAction | GetCategoriesSuccessAction | GetCategoriesFailAction | ClearCategoriesAction;
export type ShippingMethodsActions = GetShippingRequestAction | GetShippingSuccessAction | GetShippingFailAction;

export type AlertsActions =
    | GetAlertsRequestAction
    | GetAlertsSuccessAction
    | GetAlertsFailAction
    | CreateAlertRequestAction
    | CreateAlertSuccessAction
    | CreateAlertFailAction
    | DeleteAlertRequestAction
    | DeleteAlertSuccessAction
    | DeleteAlertFailAction;

export type SeniorHomesActions =
    | GetSeniorHomesRequestAction
    | GetSeniorHomesSuccessAction
    | GetSeniorHomesFailAction
    | CreateSeniorHomeRequestAction
    | CreateSeniorHomeSuccessAction
    | CreateSeniorHomeFailAction
    | DeleteSeniorHomeRequestAction
    | DeleteSeniorHomeSuccessAction
    | DeleteSeniorHomeFailAction
    | ClearSeniorHomesAction;

export type BlogsActions = GetBlogsRequestAction | GetBlogsSuccessAction | GetBlogsFailAction | ResetBlogAction;

export type CouponsActions =
    | GetCouponsRequestAction
    | GetCouponsSuccessAction
    | GetCouponsFailAction
    | CreateCouponRequestAction
    | CreateCouponSuccessAction
    | CreateCouponFailAction
    | DeleteCouponRequestAction
    | DeleteCouponSuccessAction
    | DeleteCouponFailAction
    | ResetCouponsAction;

export type FaqsActions = GetFaqsRequestAction | GetFaqsSuccessAction | GetFaqsFailAction;

// Service
export type AddToShoppingCartAction = {
    type: typeof ADD_TO_CART;
    payload: {
        service: Service;
    };
};

export type RemoveFromShoppingCartAction = {
    type: typeof REMOVE_FROM_CART;
    payload: {
        id: number;
    };
};

export type ResetShoppingCartAction = {
    type: typeof RESET_CART;
    payload: {};
};

export type ResetBlogAction = {
    type: typeof RESET_BLOG;
    payload: {};
};

export type ResetCouponsAction = {
    type: typeof RESET_COUPONS;
    payload: {};
};

export type ResetUsersAction = {
    type: typeof RESET_USERS;
    payload: {};
};

export type UpdateUserEditRequestAction = {
    type: typeof UPDATE_USER_EDIT_REQUEST;
    payload: Partial<UserUpdate>;
};

export type UpdateUserEditRequestSuccessAction = {
    type: typeof UPDATE_USER_EDIT_REQUEST_SUCCESS;
};

export type UpdateUserEditRquestFailAction = {
    type: typeof UPDATE_USER_EDIT_REQUEST_FAIL;
    payload: any;
};

export type ResetOrdersAction = {
    type: typeof RESET_ORDERS;
    payload: {};
};

// Shipping address
export type SaveShippingAddressAction = {
    type: typeof SAVE_SHIPPING_ADDRESS;
    payload: {
        data: any;
    };
};

export type SavePaymentMethodAction = {
    type: typeof SAVE_PAYMENT_METHOD;
    payload: {
        data: any;
    };
};

export type SaveStripePaymentMethodAction = {
    type: typeof SAVE_STRIPE_PAYMENT_METHOD;
    payload: {
        data: any;
    };
};

export type SetCouponAction = {
    type: typeof SET_COUPON;
    payload: any;
};

export type CartActions = AddToShoppingCartAction | RemoveFromShoppingCartAction | ResetShoppingCartAction | SaveShippingAddressAction | SavePaymentMethodAction | SaveStripePaymentMethodAction | SetCouponAction;

// Order
export type Order = {
    price: number;
    shippingPrice: number;
    address: string;
    postalCode: string;
    city: string;
    paymentMethod: any;
    stripePaymentMethod: any;
    taxPrice: number;
    totalPrice: number;
};

export type Admin = {
    paymentResult: string;
    isPaid: boolean;
    paidAt: string;
    isDelivered: boolean;
};

export type OrderActions = CreateOrderRequestAction | CreateOrderSuccessAction | CreateOrderFailAction | GetOrdersRequestAction | GetOrdersSuccessAction | GetOrdersFailAction | ResetOrdersAction;

export type CreateOrderRequestAction = {
    type: typeof CREATE_ORDER_REQUEST;
    payload: {
        order: Order;
    };
};

export type CreateOrderSuccessAction = {
    type: typeof CREATE_ORDER_SUCCESS;
    payload: any;
};

export type CreateOrderFailAction = {
    type: typeof CREATE_ORDER_FAIL;
    payload: {
        error: any;
    };
};

export type NurseActions =
    | GetNursesRequestAction
    | GetNursesSuccessAction
    | GetNursesFailAction
    | GetNurseProfileRequest
    | GetNurseProfileSuccess
    | GetNurseProfileFailed
    | GetAssignedSeniorListRequest
    | GetAssignedSeniorListSuccess
    | GetAssignedSeniorListFailed
    | GetAssignedSeniorRequest
    | GetAssignedSeniorSuccess
    | GetAssignedSeniorFailed
    | UpdateNurseRequestAction
    | UpdateNurseSuccessAction
    | UpdateNurseFailedAction
    | AddNurseRequestAction
    | AddNurseSuccessAction
    | AddNurseFailedAction
    | SignupNurseRequestAction
    | SignupNurseSuccessAction
    | SignupNurseFailedAction
    | ResetNurseMessageAction
    | SetNurseMessageAction
    | RemoveNurseRequestAction
    | RemoveNurseRequestSuccessAction
    | RemoveNurseRequestFailedAction;

export type GetNursesRequestAction = {
    type: typeof GET_NURSES_REQUEST;
};

export type GetNursesSuccessAction = {
    type: typeof GET_NURSES_SUCCESS;
    payload: any;
};

export type GetNursesFailAction = {
    type: typeof GET_NURSES_FAIL;
    payload: {
        error: any;
    };
};

export type GetNurseProfileRequest = {
    type: typeof GET_NURSE_PROFILE_REQUEST;
    payload: any;
};

export type GetNurseProfileSuccess = {
    type: typeof GET_NURSE_PROFILE_SUCCESS;
    payload: any;
};

export type GetNurseProfileFailed = {
    type: typeof GET_NURSE_PROFILE_FAILED;
    payload: any;
};

export type GetAssignedSeniorListRequest = {
    type: typeof ASSIGNED_SENIOR_LIST_REQUEST;
};

export type GetAssignedSeniorListSuccess = {
    type: typeof ASSIGNED_SENIOR_LIST_SUCCESS;
    payload: any;
};

export type GetAssignedSeniorListFailed = {
    type: typeof ASSIGNED_SENIOR_LIST_FAILED;
    payload: any;
};

export type GetAssignedSeniorRequest = {
    type: typeof ASSIGNED_SENIOR_REQUEST;
    payload: any;
};

export type GetAssignedSeniorSuccess = {
    type: typeof ASSIGNED_SENIOR_SUCCESS;
    payload: any;
};

export type GetAssignedSeniorFailed = {
    type: typeof ASSIGNED_SENIOR_FAILED;
    payload: any;
};

export type UpdateNurseRequestAction = {
    type: typeof UPDATE_NURSE_REQUEST;
    payload: any;
};

export type UpdateNurseSuccessAction = {
    type: typeof UPDATE_NURSE_SUCCESS;
};

export type UpdateNurseFailedAction = {
    type: typeof UPDATE_NURSE_FAILED;
    payload: any;
};

export type RemoveNurseRequestAction = {
    type: typeof DELETE_NURSE_REQUEST;
    payload: number;
};

export type RemoveNurseRequestSuccessAction = {
    type: typeof DELETE_NURSE_REQUEST_SUCCESS;
};

export type RemoveNurseRequestFailedAction = {
    type: typeof DELETE_NURSE_REQUEST_FAILED;
};

export type AddNurseRequestAction = {
    type: typeof ADD_NURSE_REQUEST;
    payload: any;
};

export type AddNurseSuccessAction = {
    type: typeof ADD_NURSE_SUCCESS;
};

export type AddNurseFailedAction = {
    type: typeof ADD_NURSE_FAILED;
    payload: any;
};

export type SignupNurseRequestAction = {
    type: typeof SIGNUP_NURSE_REQUSET;
    payload: any;
};

export type SignupNurseSuccessAction = {
    type: typeof SIGNUP_NURSE_SUCCESS;
};

export type SignupNurseFailedAction = {
    type: typeof SIGNUP_NURSE_FAILED;
    payload: any;
};

export type ResetNurseMessageAction = {
    type: typeof RESET_NURSE_MESSAGE;
};

export type SetNurseMessageAction = {
    type: typeof SET_NURSE_MESSAGE;
    payload: any;
};

export type ItSupportActions =
    | GetItSupportListRequestAction
    | GetItSupportListSuccessAction
    | GetItSupportListFailAction
    | GetItSupportProfileRequestAction
    | GetItSupportProfileSuccessAction
    | GetItSupportProfileFailAction
    | UpdateItSupportProfileRequestAction
    | UpdateItSupportProfileSuccessAction
    | UpdateItSupportProfileFailAction
    | SendInviteItSupportRequest
    | SendInviteItSupportSuccess
    | SendInviteItSupportFail
    | SignUpItSupportRequest
    | SignUpItSupportSuccess
    | SignUpItSupportFail
    | ResetItSupportMessageAction
    | SetItSupportMessageAction
    | RemoveItSupportProfileRequestAction
    | RemoveItSupportProfileRequestSuccessAction
    | RemoveItSupportProfileRequestFailedAction;

export type GetItSupportListRequestAction = {
    type: typeof GET_ITSUPPORT_LIST_REQUEST;
};

export type GetItSupportListSuccessAction = {
    type: typeof GET_ITSUPPORT_LIST_SUCCESS;
    payload: any;
};

export type GetItSupportListFailAction = {
    type: typeof GET_ITSUPPORT_LIST_FAIL;
    payload: any;
};

export type GetItSupportProfileRequestAction = {
    type: typeof GET_ITSUPPORT_PROFILE_REQUEST;
    payload: any;
};

export type GetItSupportProfileSuccessAction = {
    type: typeof GET_ITSUPPORT_PROFILE_SUCCESS;
    payload: any;
};

export type GetItSupportProfileFailAction = {
    type: typeof GET_ITSUPPORT_PROFILE_FAIL;
    payload: any;
};

export type UpdateItSupportProfileRequestAction = {
    type: typeof UPDATE_ITSUPPORT_PROFILE_REQUEST;
    payload: any;
};

export type UpdateItSupportProfileSuccessAction = {
    type: typeof UPDATE_ITSUPPORT_PROFILE_SUCCESS;
    payload: any;
};

export type UpdateItSupportProfileFailAction = {
    type: typeof UPDATE_ITSUPPORT_PROFILE_FAIL;
    payload: any;
};

export type SendInviteItSupportRequest = {
    type: typeof SEND_INVITE_ITSUPPORT_REQUEST;
    payload: any;
};

export type SendInviteItSupportSuccess = {
    type: typeof SEND_INVITE_ITSUPPORT_SUCCESS;
};

export type SendInviteItSupportFail = {
    type: typeof SEND_INVITE_ITSUPPORT_FAIL;
    payload: any;
};

export type SignUpItSupportRequest = {
    type: typeof SIGNUP_ITSUPPORT_REQUEST;
    payload: any;
};

export type SignUpItSupportSuccess = {
    type: typeof SIGNUP_ITSUPPORT_SUCCESS;
};

export type SignUpItSupportFail = {
    type: typeof SIGNUP_ITSUPPORT_FAIL;
    payload: any;
};

export type ResetItSupportMessageAction = {
    type: typeof RESET_ITSUPPORT_MESSAGE;
};

export type SetItSupportMessageAction = {
    type: typeof SET_ITSUPPORT_MESSAGE;
    payload: any;
};

export type RemoveItSupportProfileRequestAction = {
    type: typeof DELETE_IT_SUPPORT_PROFILE_REQUEST;
    payload: number;
};

export type RemoveItSupportProfileRequestSuccessAction = {
    type: typeof DELETE_IT_SUPPORT_PROFILE_REQUEST_SUCCESS;
};

export type RemoveItSupportProfileRequestFailedAction = {
    type: typeof DELETE_IT_SUPPORT_PROFILE_REQUEST_FAILED;
};

export type VideoMeetActions = JoinRoomRequestAction | JoinRoomRequestFailAction | JoinRoomRequestSuccessAction | ResetVideoMeetAction | SetLkTokenAction | SetPreJoinTokenAction | RemoveRoomNameAction;

export type JoinRoomRequestAction = {
    type: typeof JOIN_ROOM_REQUEST;
    payload: any;
};

export type JoinRoomRequestFailAction = {
    type: typeof JOIN_ROOM_REQUEST_FAIL;
    payload: any;
};

export type JoinRoomRequestSuccessAction = {
    type: typeof JOIN_ROOM_REQUEST_SUCCESS;
    payload: any;
};

export type ResetVideoMeetAction = {
    type: typeof RESET_VIDEO_MEET;
};

export type SetLkTokenAction = {
    type: typeof SET_LK_TOKEN;
    payload: any;
};

export type SetPreJoinTokenAction = {
    type: typeof SET_PRE_JOIN_TOKEN;
    payload: any;
};

export type RemoveRoomNameAction = {
    type: typeof REMOVE_ROOM_NAME;
    payload: any;
};

export type GetFaqsRequestAction = {
    type: typeof GET_FAQS_REQUEST;
};
export type GetFaqsSuccessAction = {
    type: typeof GET_FAQS_SUCCESS;
    payload: any[];
};
export type GetFaqsFailAction = {
    type: typeof GET_FAQS_FAIL;
    payload: {
        error: any;
    };
};

// States
export type CredentialState = {
    credential: Credential;
};

export type Member = {
    id: any;
    role: string;
    username: string;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    device_imei4?: string;
    image?: string;
    nursingHome?: string;
    department?: string;
    homeAddress?: string;
    homeCity?: string;
    homePostalCode?: string;
    nursingHomeAddress?: string;
    isAdmin?: boolean;
    chosenService?: string;
    autoAnswer?: string;
    tabletLanguage?: string;
    serviceOption?: string;
};

export type Group = {
    id: number | null;
    name: string;
    members: Member[];
};

export type GroupState = {
    id: number | null;
    name: string;
    members: Member[];
    success: boolean;
};

export type PickupPoint = {
    address1: string | null;
    address2: string | null;
    city: string | null;
    contact: string | null;
    countryCode: string | null;
    email: string | null;
    fax: string | null;
    id: string | null;
    name: string | null;
    openingHours: string | null;
    phone: string | null;
    serviceCode: string | null;
    serviceType: string | null;
    sms: string | null;
    state: string | null;
    zipcode: string | null;
};

export type CartState = {
    usePickupPoint: boolean;
    pickupPoint: PickupPoint;
    inCart: ProductType[];
    shippingMethod: string;
    name: string;
    address: string;
    postalCode: string;
    city: string;
    country: string;
    email: string;
    mobile: string;
    paymentMethod: any;
    stripePaymentMethod: any;
    price: number;
    shippingPrice: number;
    taxPrice: number;
    totalPrice: number;
    coupon: any;
    couponData: any;
    nursingHome: any;
};

export type ServicesState = {
    list: any[];
    loading: boolean;
    error: any;
};

export type ProductsState = {
    products: ProductType[];
    loading: boolean;
    error: any;
};

export type CategoriesState = {
    category?: CategoryType;
    loading: boolean;
    error: any;
};

export type ShippingMethodsState = {
    shipping?: ShippingMethod[];
    loading: boolean;
    error: any;
};

export type AlertsState = {
    list: any[];
    loading: boolean;
    deleted_at: any;
    error: any;
};

export type SeniorHomesState = {
    list: any[];
    loading: boolean;
    deleted_at: any;
    error: any;
};

export type BlogsState = {
    blogs: BlogItem[];
    loading: boolean;
    error: any;
};

export type CouponsState = {
    list: any[];
    loading: boolean;
    deleted_at: any;
    error: any;
};

export type FaqsState = {
    faqs: FaqModel[];
    loading: boolean;
    error: any;
};

export type Resources = {
    services?: ServiceItem[];
    loading: boolean;
    deleting: boolean;
    deleted_at: number;
    error: any;
};

export type Nurses = {
    list: any[];
    loading: boolean;
    error: any;
    profile: {};
    seniorList: [];
    message: {};
};

export type ItSupport = {
    list: any[];
    loading: boolean;
    error: any;
    itSupportProfile: {};
    message: {};
};

export type VideoMeet = {
    loading: boolean;
    error: any;
    message: {};
    participants: any[];
};

export type AppState = {
    user: UserState;
    users: Users;
    cart: CartState;
    services: ServicesState;
    alerts: AlertsState;
    blogs: BlogsState;
    coupons: CouponsState;
    resources: Resources;
    orders: Orders;
    seniorHomes: SeniorHomesState;
    nurses: Nurses;
    itSupport: ItSupport;
    videoMeet: VideoMeet;
    products: ProductsState;
    categories: CategoriesState;
    shippingMethods: ShippingMethodsState;
    faqs: FaqsState;
    senior: SeniorState;
    headNurse: HeadNurseState;
    subscription: SubscriptionState;
    region: RegionState;
};

export type FaqModel = {
    id: number;
    category: CategoryForFaq;
    content: string;
};

export type CategoryForFaq = {
    id: number;
    name: string;
    slug: string;
};

export type BlogItem = {
    id: number;
    title: string;
    url: string;
    topics: string | null;
    cover: string;
    coverType: string;
    content: any;
    contentPreview: string;
    featured: boolean;
    orderValue: number;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
};

export type ProductType = {
    id: number;
    productId?: string;
    name?: string;
    category: string;
    image?: string;
    price?: number;
    isActive?: boolean;
    shippingCategory?: string;
    stripeProductId?: string;
    stripeShippingRateId?: string;
    stripeShippingRateIdFree?: string;
    priceType?: string;
    period?: number;
    sortNumber?: number;
    showNameLine?: boolean;
    locked?: boolean;
    firstBox: FirstBoxType;
    secondBox: BlocksContent;
    thirdBox: BlocksContent;
    emphasized?: boolean;
    selected?: boolean;
    regions?: string[];
    // Region-specific pricing
    priceId?: string;
    formattedPrice?: string;
    currency?: string;
    isAvailable?: boolean;
    images?: string[];
};

export type CMSProductType = {
    id: number;
    attributes: {
        Name?: string;
        SortNumber: number;
        productId?: string;
        productTestId?: string;
        StripeProductId?: string;
        StripeProductTestId?: string;
        PriceType?: string;
        Period?: number;
        Active?: boolean;
        Price?: number;
        ShowNameLine?: boolean;
        createdAt: string;
        updatedAt: string;
        publishedAt: string;
        Locked?: boolean;
        category: {
            data: {
                id: number;
                attributes: {
                    slug: string;
                };
            };
        };
        FirstBox: FirstBoxType;
        SecondBox: BlocksContent;
        ThirdBox: BlocksContent;
        Emphasized: boolean;
        Selected: boolean;
        Regions?: string[];
        Images?: CMSImagesType;
    };
};

export type CMSFaqType = {
    id: number;
    attributes: {
        Category: {
            data: {
                id: number;
                attributes: {
                    Name: string;
                    slug: string;
                };
            };
        };
        Content: BlocksContent;
    };
};

export type CMSBlogType = {
    id: number;
    attributes: {
        Title: string;
        SlugURL: string;
        Featured: boolean;
        Topics: string;
        Cover: CoverBoxType;
        ContentPreview: string;
        Content: BlocksContent;
        Order: number;
        createdBy?: CMSCreatorType | null;
        createdAt: string;
        updatedAt: string;
        publishedAt: string;
    };
};

// export type SubCategoriesSlugs = "tablet" | "tablet-stand" | "alarm-extra-gadget" | "alarm-type" | "alarm-set-up-service" | "alarm-operator" | "phone" | "phone-set-up-service" | "phone-operato" | "phone-service-payment" | "phone-gadget";

export type CMSImageType = {
    data: {
        id: number;
        attributes: {
            url?: string;
        };
    };
};

export type CMSImagesType = {
    data: {
        id: number;
        attributes: {
            url: string;
        };
    }[];
};

export type CMSVideoType = {
    data: {
        id: number;
        attributes: {
            url?: string;
        };
    };
};

export type CMSYoutubeVideoType = {
    data: {
        id: number;
        attributes: {
            url?: string;
        };
    };
};

export type CMSCreatorType = {
    data: {
        id: number;
        attributes: {
            firstname?: string;
            lastname?: string;
            username?: string;
        };
    };
};

export type ImageBoxType = {
    id: number;
    __component: "boxes.image";
    Image: CMSImageType;
};

export type VideoBoxType = {
    id: number;
    __component: "boxes.video";
    Video: CMSVideoType;
};

export type YoutubeBoxType = {
    id: number;
    __component: "boxes.youtube";
    VideoId: string;
};

export type DynamicTextType = {
    id: number;
    __component: "boxes.dynamic-text";
    Content: BlocksContent;
};

export type FirstBoxComponentType = ImageBoxType | DynamicTextType;
export type FirstBoxType = FirstBoxComponentType[];

export type CoverBoxComponentType = ImageBoxType | VideoBoxType | YoutubeBoxType;
export type CoverBoxType = CoverBoxComponentType[];

export type SubCategoryType = {
    id: number;
    attributes: {
        slug: string;
        Name: string;
        Selection: "Single" | "Multiple";
        Description: BlocksContent;
        SortNumber: number;
        Optional: boolean;
    };
};

export type CategoryType = {
    id: number;
    attributes: {
        slug: string;
        Name: string;
        sub_categories?: {
            data: SubCategoryType[];
        };
        OrderConfirmationNoCardPayer?: number;
        OrderProcessConfirmationToCustomer?: number;
        RelativeCreateAccount?: number;
        RelativeAccountDone?: number;
        customerTrialEmailId?: number;
        customerTrialEndEmailId?: number;
        customerSubStartEmailId?: number;
        customerSubEndEmailId?: number;
        customerSeniorEmailId?: number;
    };
};

export type CMSShippingMethod = {
    id: string;
    attributes: {
        Name: string;
        ShippingMethod: string;
        StripeShippingRateId_Test: string;
        StripeFreeShippingRateId_Test: string;
        StripeShippingRateId_Prod: string;
        StripeFreeShippingRateId_Prod: string;
        Price: number;
    };
};

export type ShippingMethod = {
    id: string;
    name: string;
    shippingMethod: string;
    stripeShippingRateId: string;
    stripeFreeShippingRateId: string;
    price: number;
};

/*  Head Nurse and Senior Types */

export const ADD_SENIOR_REQUEST = "ADD_SENIOR_REQUEST";
export const ADD_SENIOR_SUCCESS = "ADD_SENIOR_SUCCESS";
export const ADD_SENIOR_FAIL = "ADD_SENIOR_FAIL";

export type Senior = {
    username: string;
    firstName: string;
    lastName: string;
    password: string;
    country?: string;
};

export type SeniorState = {
    senior: Senior;
    loading: boolean;
    error: any;
};

export interface AddSeniorRequestAction {
    type: typeof ADD_SENIOR_REQUEST;
    payload: { senior: Senior; history: any };
}

export interface AddSeniorSuccessAction {
    type: typeof ADD_SENIOR_SUCCESS;
}

export interface AddSeniorFailAction {
    type: typeof ADD_SENIOR_FAIL;
    payload: { error: any };
}

export type SeniorAction = AddSeniorRequestAction | AddSeniorSuccessAction | AddSeniorFailAction;

// head nurse invite

export const INVITE_HEAD_NURSE_REQUEST = "INVITE_HEAD_NURSE_REQUEST";
export const INVITE_HEAD_NURSE_SUCCESS = "INVITE_HEAD_NURSE_SUCCESS";
export const INVITE_HEAD_NURSE_FAIL = "INVITE_HEAD_NURSE_FAIL";

// add nurse (head nurse only)
export const ADD_NURSE_BY_HN_REQUEST = "ADD_NURSE_BY_HN_REQUEST";
export const ADD_NURSE_BY_HN_SUCCESS = "ADD_NURSE_BY_HN_SUCCESS";
export const ADD_NURSE_BY_HN_FAIL = "ADD_NURSE_BY_HN_FAIL";

export type HeadNurseInvite = {
    firstName: string;
    lastName: string;
    email: string;
    seniorHomeIds: number;
};

export type AddNurseByHNRequest = {
    firstName: string;
    lastName: string;
    email: string;
    isNurse: boolean;
    seniorHomeIds: number;
};

export interface InviteHeadNurseRequestAction {
    type: typeof INVITE_HEAD_NURSE_REQUEST;
    payload: {
        headNurseInvite: HeadNurseInvite;
        history: any;
    };
}

export interface InviteHeadNurseSuccessAction {
    type: typeof INVITE_HEAD_NURSE_SUCCESS;
}

export interface InviteHeadNurseFailAction {
    type: typeof INVITE_HEAD_NURSE_FAIL;
    payload: { error: any };
}

export interface AddNurseByHeadNurseRequestAction {
    type: typeof ADD_NURSE_BY_HN_REQUEST;
    payload: AddNurseByHNRequest;
}

export interface AddNurseByHeadNurseSuccessAction {
    type: typeof ADD_NURSE_BY_HN_SUCCESS;
}

export interface AddNurseByHeadNurseFailAction {
    type: typeof ADD_NURSE_BY_HN_FAIL;
    payload: { error: any };
}

export interface HeadNurseState {
    headNurseInvite: {
        data: HeadNurseInvite;
        loading: boolean;
        error: any;
    };
    addNurse: {
        data: AddNurseByHNRequest;
        loading: boolean;
        error: any;
    };

    customerInvite: {
        data: CustomerInvite;
        loading: boolean;
        error: any;
    };
    acceptCustomerInvite: {
        loading: boolean;
        error: null;
        data: null;
    };
    invitedCustomerData: {
        loading: boolean;
        error: any | null;
        data: InvitedCustomer;
    };
    nurses: {
        list: any[];
        loading: boolean;
        error: any;
    };

    seniors: {
        list: any[];
        loading: boolean;
        error: any;
    };

    nurse: {
        data: any;
        loading: boolean;
        error: any;
    };

    editSenior: {
        loading: boolean;
        error: null;
        data: null;
    };
    message: {
        status?: number;
        message?: string;
        data?: any;
    };
    editHeadNurseProfile: {
        loading: boolean;
        error: string | null;
        data: any;
    };
    loading: boolean;
    error: any;
}

// accept head nurse invite

export const ACCEPT_HEAD_NURSE_INVITE_REQUEST = "ACCEPT_HEAD_NURSE_INVITE_REQUEST";
export const ACCEPT_HEAD_NURSE_INVITE_SUCCESS = "ACCEPT_HEAD_NURSE_INVITE_SUCCESS";
export const ACCEPT_HEAD_NURSE_INVITE_FAIL = "ACCEPT_HEAD_NURSE_INVITE_FAIL";

export type AcceptHeadNurseInviteRequest = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    mobileNumber: string;
    token: string;
};

export type AcceptHeadNurseInviteRequestAction = {
    type: typeof ACCEPT_HEAD_NURSE_INVITE_REQUEST;
    payload: AcceptHeadNurseInviteRequest;
};

export type AcceptHeadNurseInviteSuccessAction = {
    type: typeof ACCEPT_HEAD_NURSE_INVITE_SUCCESS;
};
export interface AcceptHeadNurseInviteFailAction {
    type: typeof ACCEPT_HEAD_NURSE_INVITE_FAIL;
    payload: {
        error: any;
    };
}

// nurses under head nurse listing
export const GET_NURSES_BY_HN_REQUEST = "GET_NURSES_BY_HN_REQUEST";
export const GET_NURSES_BY_HN_SUCCESS = "GET_NURSES_BY_HN_SUCCESS";
export const GET_NURSES_BY_HN_FAIL = "GET_NURSES_BY_HN_FAIL";

export type GetNursesByHNRequestAction = {
    type: typeof GET_NURSES_BY_HN_REQUEST;
};
export type GetNursesByHNSuccessAction = {
    type: typeof GET_NURSES_BY_HN_SUCCESS;
    payload: any;
};
export type GetNursesByHNFailAction = {
    type: typeof GET_NURSES_BY_HN_FAIL;
    payload: { error: any };
};

// edit nurse profile by HN
export const EDIT_NURSE_PROFILE_REQUEST = "EDIT_NURSE_PROFILE_REQUEST";
export const EDIT_NURSE_PROFILE_SUCCESS = "EDIT_NURSE_PROFILE_SUCCESS";
export const EDIT_NURSE_PROFILE_FAIL = "EDIT_NURSE_PROFILE_FAIL";

export type EditNurseProfileRequest = {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    mobileNumber: string;
    seniorHomeIds: number[];
    seniors: number[];
};

export interface EditNurseProfileRequestAction {
    type: typeof EDIT_NURSE_PROFILE_REQUEST;
    payload: EditNurseProfileRequest;
}

export interface EditNurseProfileSuccessAction {
    type: typeof EDIT_NURSE_PROFILE_SUCCESS;
}

export interface EditNurseProfileFailAction {
    type: typeof EDIT_NURSE_PROFILE_FAIL;
    payload: { error: any };
}

// customer invite by head nurse
export const INVITE_CUSTOMER_REQUEST = "INVITE_CUSTOMER_REQUEST";
export const INVITE_CUSTOMER_SUCCESS = "INVITE_CUSTOMER_SUCCESS";
export const INVITE_CUSTOMER_FAIL = "INVITE_CUSTOMER_FAIL";

export type CustomerInvite = {
    firstName: string;
    lastName: string;
    email: string;
};

export interface InviteCustomerRequestAction {
    type: typeof INVITE_CUSTOMER_REQUEST;
    payload: { customerInvite: CustomerInvite; history: any };
}

export interface InviteCustomerSuccessAction {
    type: typeof INVITE_CUSTOMER_SUCCESS;
}

export interface InviteCustomerFailAction {
    type: typeof INVITE_CUSTOMER_FAIL;
    payload: { error: any };
}

// get specific nurse by head nurse
export const GET_NURSE_BY_HN_ID_REQUEST = "GET_NURSE_BY_HN_ID_REQUEST";
export const GET_NURSE_BY_HN_ID_SUCCESS = "GET_NURSE_BY_HN_ID_SUCCESS";
export const GET_NURSE_BY_HN_ID_FAIL = "GET_NURSE_BY_HN_ID_FAIL";

export type GetNurseByHNIdRequest = {
    id: number;
};

export type GetNurseByHNIdRequestAction = {
    type: typeof GET_NURSE_BY_HN_ID_REQUEST;
    payload: GetNurseByHNIdRequest;
};

export type GetNurseByHNIdSuccessAction = {
    type: typeof GET_NURSE_BY_HN_ID_SUCCESS;
    payload: any;
};

export type GetNurseByHNIdFailAction = {
    type: typeof GET_NURSE_BY_HN_ID_FAIL;
    payload: { error: any };
};

// get senior List by head nurse

export const GET_SENIORS_BY_HN_REQUEST = "GET_SENIORS_BY_HN_REQUEST";
export const GET_SENIORS_BY_HN_SUCCESS = "GET_SENIORS_BY_HN_SUCCESS";
export const GET_SENIORS_BY_HN_FAIL = "GET_SENIORS_BY_HN_FAIL";

export interface GetSeniorsByHNRequestAction {
    type: typeof GET_SENIORS_BY_HN_REQUEST;
}

export interface GetSeniorsByHNSuccessAction {
    type: typeof GET_SENIORS_BY_HN_SUCCESS;
    payload: any[];
}

export interface GetSeniorsByHNFailAction {
    type: typeof GET_SENIORS_BY_HN_FAIL;
    payload: {
        error: any;
    };
}

//  senior edit by Head
export const EDIT_SENIOR_BY_HN_REQUEST = "EDIT_SENIOR_BY_HN_REQUEST";
export const EDIT_SENIOR_BY_HN_SUCCESS = "EDIT_SENIOR_BY_HN_SUCCESS";
export const EDIT_SENIOR_BY_HN_FAIL = "EDIT_SENIOR_BY_HN_FAIL";

export type EditSeniorByHNRequest = {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    username: string;
    mobileNumber: string;
    homeAddress: string;
    hasItSupport: number;
    hasNurseSupport: number;
    hasNurseCalling: number;
    nurses: number[];
    customerId: number;
};

export interface EditSeniorByHNRequestAction {
    type: typeof EDIT_SENIOR_BY_HN_REQUEST;
    payload: EditSeniorByHNRequest;
}

export interface EditSeniorByHNSuccessAction {
    type: typeof EDIT_SENIOR_BY_HN_SUCCESS;
    payload?: any;
}

export interface EditSeniorByHNFailAction {
    type: typeof EDIT_SENIOR_BY_HN_FAIL;
    payload: {
        error: any;
    };
}

export const ACCEPT_CUSTOMER_INVITE_REQUEST = "ACCEPT_CUSTOMER_INVITE_REQUEST";
export const ACCEPT_CUSTOMER_INVITE_SUCCESS = "ACCEPT_CUSTOMER_INVITE_SUCCESS";
export const ACCEPT_CUSTOMER_INVITE_FAIL = "ACCEPT_CUSTOMER_INVITE_FAIL";

export type AcceptCustomerInviteRequest = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    role: string;
    mobileNumber: string;
    token: string;
};

export interface AcceptCustomerInviteRequestAction {
    type: typeof ACCEPT_CUSTOMER_INVITE_REQUEST;
    payload: AcceptCustomerInviteRequest;
}

export interface AcceptCustomerInviteSuccessAction {
    type: typeof ACCEPT_CUSTOMER_INVITE_SUCCESS;
}

export interface AcceptCustomerInviteFailAction {
    type: typeof ACCEPT_CUSTOMER_INVITE_FAIL;
    payload: {
        error: any;
    };
}

// delete customer by HN
export const DELETE_CUSTOMER_REQUEST = "DELETE_CUSTOMER_REQUEST";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_FAIL = "DELETE_CUSTOMER_FAIL";

export type DeleteCustomerRequestAction = {
    type: typeof DELETE_CUSTOMER_REQUEST;
    payload: {
        customerId: number;
    };
};

export type DeleteCustomerSuccessAction = {
    type: typeof DELETE_CUSTOMER_SUCCESS;
};

export type DeleteCustomerFailAction = {
    type: typeof DELETE_CUSTOMER_FAIL;
    payload: {
        error: any;
    };
};

// clear message :
export const CLEAR_HEAD_NURSE_MESSAGE = "CLEAR_HEAD_NURSE_MESSAGE";

export interface ClearHeadNurseMessageAction {
    type: typeof CLEAR_HEAD_NURSE_MESSAGE;
}

//  edit head nurse profile request

export const EDIT_HEAD_NURSE_PROFILE_REQUEST = "EDIT_HEAD_NURSE_PROFILE_REQUEST";
export const EDIT_HEAD_NURSE_PROFILE_SUCCESS = "EDIT_HEAD_NURSE_PROFILE_SUCCESS";
export const EDIT_HEAD_NURSE_PROFILE_FAIL = "EDIT_HEAD_NURSE_PROFILE_FAIL";

export interface EditHeadNurseProfileRequest {
    id: number | string;
    firstName: string;
    lastName: string;
    email: string;
    mobileNumber: string;
    seniorHomeIds?: number | null;
}

export interface EditHeadNurseProfileRequestAction {
    type: typeof EDIT_HEAD_NURSE_PROFILE_REQUEST;
    payload: { data: EditHeadNurseProfileRequest; history: any };
}

export interface EditHeadNurseProfileSuccessAction {
    type: typeof EDIT_HEAD_NURSE_PROFILE_SUCCESS;
    payload: any;
}

export interface EditHeadNurseProfileFailAction {
    type: typeof EDIT_HEAD_NURSE_PROFILE_FAIL;
    payload: string;
}

// customer invitation data for registration form

export type InvitedCustomer = {
    id: number | null;
    firstName: string;
    lastName: string;
    email: string;
    token: string;
    seniorHomeIds: number | null;
    createdAt: string | null;
    updatedAt: string | null;
    deletedAt: string | null;
    username: string;
    role: string;
};
export const INVITED_CUSTOMER_DATA_REQUEST = "INVITED_CUSTOMER_DATA_REQUEST";
export const INVITED_CUSTOMER_DATA_SUCCESS = "INVITED_CUSTOMER_DATA_SUCCESS";
export const INVITED_CUSTOMER_DATA_FAIL = "INVITED_CUSTOMER_DATA_FAIL";
export const CLEAR_INVITED_CUSTOMER_DATA = "CLEAR_INVITED_CUSTOMER_DATA";

export type InvitedCustomerDataRequestAction = {
    type: typeof INVITED_CUSTOMER_DATA_REQUEST;
    payload: any;
};
export type InvitedCustomerDataSuccessAction = {
    type: typeof INVITED_CUSTOMER_DATA_SUCCESS;
    payload: any;
};
export type InvitedCustomerDataFailAction = {
    type: typeof INVITED_CUSTOMER_DATA_FAIL;
    payload: { error: any };
};

export interface ClearInvitedCustomerDataAction {
    type: typeof CLEAR_INVITED_CUSTOMER_DATA;
}

export type HeadNurseAction =
    | InviteHeadNurseRequestAction
    | InviteHeadNurseSuccessAction
    | InviteHeadNurseFailAction
    | AddNurseByHeadNurseRequestAction
    | AddNurseByHeadNurseSuccessAction
    | AddNurseByHeadNurseFailAction
    | AcceptHeadNurseInviteRequestAction
    | AcceptHeadNurseInviteSuccessAction
    | AcceptHeadNurseInviteFailAction
    | GetNursesByHNRequestAction
    | GetNursesByHNSuccessAction
    | GetNursesByHNFailAction
    | GetNurseByHNIdRequestAction
    | GetNurseByHNIdSuccessAction
    | GetNurseByHNIdFailAction
    | EditNurseProfileRequestAction
    | EditNurseProfileSuccessAction
    | EditNurseProfileFailAction
    | InviteCustomerRequestAction
    | InviteCustomerSuccessAction
    | InviteCustomerFailAction
    | GetSeniorsByHNRequestAction
    | GetSeniorsByHNSuccessAction
    | GetSeniorsByHNFailAction
    | EditSeniorByHNRequestAction
    | EditSeniorByHNSuccessAction
    | EditSeniorByHNFailAction
    | AcceptCustomerInviteRequestAction
    | AcceptCustomerInviteSuccessAction
    | AcceptCustomerInviteFailAction
    | DeleteCustomerRequestAction
    | DeleteCustomerSuccessAction
    | DeleteCustomerFailAction
    | LoginUserRequestAction
    | ClearHeadNurseMessageAction
    | EditHeadNurseProfileRequestAction
    | EditHeadNurseProfileSuccessAction
    | EditHeadNurseProfileFailAction
    | InvitedCustomerDataRequestAction
    | InvitedCustomerDataSuccessAction
    | InvitedCustomerDataFailAction
    | ClearInvitedCustomerDataAction;

// Subscription
export const CANCEL_SUBSCRIPTION_REQUEST = "CANCEL_SUBSCRIPTION_REQUEST";
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS";
export const CANCEL_SUBSCRIPTION_FAIL = "CANCEL_SUBSCRIPTION_FAIL";

export const GET_SUBSCRIPTION_REQUEST = "GET_SUBSCRIPTION_REQUEST";
export const GET_SUBSCRIPTION_SUCCESS = "GET_SUBSCRIPTION_SUCCESS";
export const GET_SUBSCRIPTION_FAIL = "GET_SUBSCRIPTION_FAIL";

export const START_TRIAL_REQUEST = "START_TRIAL_REQUEST";
export const START_TRIAL_SUCCESS = "START_TRIAL_SUCCESS";
export const START_TRIAL_FAIL = "START_TRIAL_FAIL";

export const CLEAR_CATEGORIES = "CLEAR_CATEGORIES";

export type CancelSubscriptionRequestAction = {
    type: typeof CANCEL_SUBSCRIPTION_REQUEST;
    payload: {
        history: any;
    };
};

export type CancelSubscriptionSuccessAction = {
    type: typeof CANCEL_SUBSCRIPTION_SUCCESS;
};

export type CancelSubscriptionFailAction = {
    type: typeof CANCEL_SUBSCRIPTION_FAIL;
    payload: {
        error: any;
    };
};

export type CancelSubscriptionAction = CancelSubscriptionRequestAction | CancelSubscriptionSuccessAction | CancelSubscriptionFailAction;

export type GetSubscriptionRequestAction = {
    type: typeof GET_SUBSCRIPTION_REQUEST;
    payload: {
        id: number;
    };
};

export type GetSubscriptionSuccessAction = {
    type: typeof GET_SUBSCRIPTION_SUCCESS;
    payload: any;
};

export type GetSubscriptionFailAction = {
    type: typeof GET_SUBSCRIPTION_FAIL;
    payload: {
        error: any;
    };
};

export type SubscriptionAction = GetSubscriptionRequestAction | GetSubscriptionSuccessAction | GetSubscriptionFailAction;

// Region
export const SET_REGION = "SET_REGION";
export const SET_REGION_SUGGESTION = "SET_REGION_SUGGESTION";
export const GET_SECTION_PRICES_REQUEST = "GET_SECTION_PRICES_REQUEST";
export const GET_SECTION_PRICES_SUCCESS = "GET_SECTION_PRICES_SUCCESS";
export const GET_SECTION_PRICES_FAIL = "GET_SECTION_PRICES_FAIL";

export type RegionState = {
    code: string;
    suggestion: string | null;
    loading: boolean;
    error: any;
};

export type SetRegionAction = {
    type: typeof SET_REGION;
    payload: string;
};

export type SetRegionSuggestionAction = {
    type: typeof SET_REGION_SUGGESTION;
    payload: string | null;
};

export type GetSectionPricesRequestAction = {
    type: typeof GET_SECTION_PRICES_REQUEST;
    payload: { region: string; productIds: string[] };
};

export type GetSectionPricesSuccessAction = {
    type: typeof GET_SECTION_PRICES_SUCCESS;
};

export type GetSectionPricesFailAction = {
    type: typeof GET_SECTION_PRICES_FAIL;
    payload: { error: any };
};

export type RegionAction = SetRegionAction | SetRegionSuggestionAction | GetSectionPricesRequestAction | GetSectionPricesSuccessAction | GetSectionPricesFailAction;
